export interface NavItem {
  label: string;
  path: string;
  icon: string;
  matches: string[];
}

export const NAV_ITEMS: NavItem[] = [
  { label: "首页", path: "/", icon: "ri-home-5-line", matches: ["/"] },
  { label: "女优分类", path: "/category", icon: "ri-user-star-line", matches: ["/category", "/detail/actress"] },
  { label: "影视作品", path: "/work-list", icon: "ri-film-line", matches: ["/work-list", "/detail/work"] },
  { label: "新闻动态", path: "/news", icon: "ri-newspaper-line", matches: ["/news", "/detail/news"] },
  { label: "关于", path: "/about", icon: "ri-information-line", matches: ["/about"] },
];